<template>
  <span class="ui-toggle" :class="['ui-toggle-' + size, { 'is-disabled': disabled }]">
    <input v-bind="$attrs" class="ui-toggle-input" type="checkbox" role="switch"
      :checked="value" :aria-checked="String(value)" :disabled="disabled" @change="change" />
    <span class="ui-toggle-track" aria-hidden="true"><span class="ui-toggle-thumb" /></span>
  </span>
</template>
<script>
// 展示型开关：不持有业务状态、不读写存储。原生checkbox保留标签点击、空格及焦点行为。
// 图形使用普通span和Flex居中，避免不同浏览器对input伪元素/默认边框处理不一致。
export default {
  name: 'UiToggle',
  inheritAttrs: false,
  props: {
    value: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    size: { type: String, default: 'medium', validator: value => ['small', 'medium'].includes(value) }
  },
  methods: {
    change(event) {
      if (this.disabled) return
      const checked = event.target.checked
      this.$emit('input', checked)
      this.$emit('change', checked)
    }
  }
}
</script>
<style scoped>
.ui-toggle { --toggle-width:42px;--toggle-height:24px;--toggle-gap:3px;display:inline-flex;align-items:center;justify-content:center;position:relative;flex:none;width:44px;min-width:44px;height:44px;box-sizing:border-box;vertical-align:middle; }
.ui-toggle-small { --toggle-width:36px;--toggle-height:20px;--toggle-gap:2px; }
.ui-toggle > .ui-toggle-input { position:absolute;inset:0;z-index:1;width:100%;height:100%;margin:0;padding:0;border:0;opacity:0;cursor:pointer; }
.ui-toggle-track { display:flex;align-items:center;flex:none;width:var(--toggle-width);height:var(--toggle-height);padding:var(--toggle-gap);border:0;border-radius:999px;box-sizing:border-box;background:var(--toggle-off-color,#b8c0cd);pointer-events:none;transition:background-color .15s ease; }
.ui-toggle-thumb { display:block;flex:none;width:calc(var(--toggle-height) - 2 * var(--toggle-gap));height:calc(var(--toggle-height) - 2 * var(--toggle-gap));border-radius:50%;background:var(--toggle-thumb-color,#fff);transition:transform .15s ease; }
.ui-toggle-input:checked + .ui-toggle-track { background:var(--toggle-on-color,#1769e8); }
.ui-toggle-input:checked + .ui-toggle-track .ui-toggle-thumb { transform:translateX(calc(var(--toggle-width) - var(--toggle-height))); }
/* :focus兜底旧浏览器；支持focus-visible时鼠标点击不显示键盘焦点环。 */
.ui-toggle-input:focus + .ui-toggle-track { outline:2px solid var(--toggle-focus-color,#8275d7);outline-offset:3px; }
.ui-toggle-input:focus:not(:focus-visible) + .ui-toggle-track { outline:none; }
.is-disabled { opacity:.5; }.ui-toggle-input:disabled { cursor:not-allowed; }
@media(prefers-reduced-motion:reduce) { .ui-toggle-track,.ui-toggle-thumb { transition:none; } }
@media(forced-colors:active) { .ui-toggle-track { outline:1px solid ButtonText; }.ui-toggle-thumb { background:ButtonText; } }
</style>
